{
  "#ABC_ANALYSIS": {
    "APP_TITLE": "ESL ABC Analysis",
    "STORAGE_SELECTION": {
      "SUBTITLE": "Select storage location",
      "MENU_ITEM": "Storage location selection"
    },
    "STORAGE_LOCATION_HEADER": {
      "CATEGORY": "Segment",
      "STORAGE_LOCATION": "Storage location",
      "CONFIGURATION": "Analysis variant"
    },
    "CATEGORY_SELECTION": {
      "SUBTITLE": "Select segment",
      "MENU_ITEM": "Segment selection",
      "PIE_CHART_TITLE": "Item distribution by segments",
      "CHANGE_ESL": "Toggle ESL",
      "FLASH_ESL": "Flash ESL",
      "BUTTONS": {
        "ARTIKEL": "Item distribution",
        "DECKUNGSBEITRAG": "Contribution margin distribution",
        "NETTO": "Net distribution",
        "LAGERWERT": "Stock value distribution"
      }
    },
    "CATEGORY_CARD": {
      "CATEGORY": "Segment",
      "PRODUCTS": "Items",
      "OF": "of",
      "CONTRIBUTION_MARGIN": "CM",
      "NET": "Net",
      "STOCK_VALUE": "Stock value",
      "STOCK_QUANTITY": "Stock quantity",
      "STOCK_UNIT": "Pieces"
    },
    "PRODUCT_CARD": {
      "SUPPLIER": "Supplier",
      "PRODUCT_DETAILS": "Item details",
      "UNIT": "Unit",
      "CONTRIBUTION_MARGIN": "CM",
      "NET": "Net",
      "STOCK_UNIT": "Stock unit",
      "STOCK_QUANTITY": "Stock quantity",
      "STOCK_VALUE": "Stock value",
      "SINGLE_PRICE": "Unit price",
      "LOCATION": "Location"
    },
    "CATEGORY_DETAIL": {
      "SUBTITLE": "Item overview",
      "MENU_ITEM": "Item overview",
      "CHANGE_ESL": "Toggle ESL",
      "FLASH_ESL": "Flash ESL"
    },
    "CONFIGURATION": {
      "SUBTITLE": "Configuration",
      "MENU_ITEM": "Configuration",
      "SETTINGS_TITLE": "ESL ABC Analysis",
      "HEADER_TITLE": "Set up ABC analysis",
      "HEADER_SUBTITLE": "Please fill in the input field to configure the ABC analysis.",
      "LABEL": "Analysis variant",
      "PLACEHOLDER": "Please select a variant"
    },
    "GUARD": {
      "MULTI_CONFIG": "Multiple ABC configurations available, please select one.",
      "NO_CONFIG": "No ABC configuration available."
    },
    "NO_DATA": {
      "TITLE": "No data available!",
      "SUBTITLE": "No segments found for the selected storage location.",
      "SUBTITLE2": "Please check if the storage location contains items."
    },
    "SERVICE": {
      "QUANTITY": "Item distribution by segments",
      "CONTRIBUTION_MARGIN": "Contribution margin distribution by segments",
      "NET": "Net distribution by segments",
      "STOCK_VALUE": "Stock value distribution by segments",
      "PRODUCT": "Item"
    }
  }
}
